/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as MesAct from '../../Actions/MesActions';
import { getGlyphe, toCalendrier, fromNow } from '../../App_Code/Utils';
import SensCommunication from '../../App_Data/SensCommunication';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import SelecteurDate from '../SelecteurDate';
import Tableau from '../Tableau';
import LigneMessageNG from './LigneMessageNG';

const AlertePasDeMes = () => (
    <div className="jumbotron text-center">
        <h1 className="display-4">Vous n&apos;avez pas de messages.</h1>
    </div>
);

const LigneMessage = ({ Mes, history, actions }) => {
    const {
        SensCom, DateSaisie, Ind1, Ind2, Objet, NumAuto, NumAff, VuParClient, Attachement,
    } = Mes;
    const estMessageSyndic = SensCom === 2 || SensCom === 12;
    const sensCom = SensCommunication(SensCom);

    return (
        <tr
            className={`clickable-row ${VuParClient === 0 ? 'table-warning' : ''}`}
            onClick={() => {
                actions.mesMarquerVuParClient(NumAuto);
                history.push({
                    pathname: '/MaMessagerie/Message',
                    state: { NumAuto },
                });
            }}
        >
            <td>{toCalendrier(DateSaisie)}</td>
            <td>
                <img src={getGlyphe(Ind1, estMessageSyndic)} alt={Ind1.Nom} /> {Ind1.Nom}
            </td>
            <td className="font-weight-bold td-truncate">{Objet}</td>
            <td>
                <img src={getGlyphe(Ind2, !estMessageSyndic)} alt={Ind2.Nom} /> {Ind2.Nom}
            </td>
            <td>
                <i className={sensCom.Icone} title={sensCom.Type} />
                {Attachement && <i className="fas fa-paperclip ml-2" title="Pièce jointe" />}
            </td>
            <td className="text-right">{NumAff}</td>
        </tr>
    );
};

const AfficheTableau = ({ Messages }) => {
    const Entete = (
        <tr>
            <th scope="col">Date</th>
            <th scope="col">De</th>
            <th scope="col">Objet</th>
            <th scope="col">À</th>
            <th scope="col">Infos</th>
            <th scope="col" className="text-right">
                Affaire
            </th>
        </tr>
    );

    return <Tableau Entete={Entete} Lignes={Messages} />;
};

const AfficheTableauNG = ({ Messages }) => {
    const Entete = (
        <tr>
            <th scope="col" />
            <th scope="col">Date</th>
            <th scope="col">De</th>
            <th scope="col" className="text-center">Type</th>
            <th scope="col" className="text-center">Catégorie</th>
            <th scope="col">Objet</th>
            <th scope="col">À</th>
            <th scope="col" />
            {/* <th scope="col" className="text-right">
                Affaire
            </th> */}
        </tr>
    );

    return <Tableau Entete={Entete} Lignes={Messages} />;
};

class MaMess extends Component {
    componentDidMount() {
        this.props.actions.mesObtenirMessages();
    }

    ChangementDate = (dateDebut) => {
        if (dateDebut) {
            this.props.actions.mesDateDebut(dateDebut);
        }
    };

    render() {
        const { Messages, DateDeb, history } = this.props;
        const DateTime = new Date(DateDeb).getTime();

        const MessagesNonLus = Messages.filter(message => !message.VuParClient);
        const MessagesLus = Messages.filter(message => message.VuParClient && new Date(message.DateSaisie).getTime() >= DateTime);
        const lsMessages = MessagesNonLus.concat(MessagesLus).map((message, index) => ( 
            <LigneMessageNG key={message.NumAuto} Mes={message} history={history} actions={this.props.actions} />
        ));

        return (
            <React.Fragment>
                <div className="d-flex justify-content-between">
                    <SelecteurDate
                        label="Messages lus à partir du :"
                        valeurDate={DateDeb}
                        onDayChange={this.ChangementDate}
                    />
                    <div>
                        <Link
                            to={'/MaMessagerie/Ecrire'}
                            className="btn btn-primary float-right mb-3"
                        >
                            Nouvelle demande au syndic
                        </Link>
                    </div>
                </div>
                {lsMessages.length > 0 ? <AfficheTableauNG Messages={lsMessages} />: <AlertePasDeMes />}
            </React.Fragment>
        );
    }
}
MaMess.displayName = 'MaMess';
MaMess.requiredProps = [
    'Messages', // Liste des messages
    'DateDeb', // Date de début des messages lus
];

function mapStateToProps({ 
    MesStore: { Messages, DateDeb },
}) {
    return { Messages, DateDeb };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(MesAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(MaMess));



// WEBPACK FOOTER //
// ./src/components/MaMess/index.js